<template>
  <div class="sp_meeting_widget_container" ref="iframeContainer">
    <iframe class="sp_meeting_widget" :style="iframeStyle" ref="iframe" :srcdoc="embedCode"></iframe>
  </div>
</template>

<script>
export default {
  name: 'MeetingWidget',
  props: {
    embedCode: {
      type: String,
      required: true,
    },
    onSuccess: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      iframeStyle: {},
      resizeObserver: null,
      deviceWidth: 1620,
    };
  },
  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  mounted() {
    this.adjustSize();

    this.resizeObserver = new ResizeObserver(() => {
      this.$nextTick(() => {
        this.adjustSize();
      });
    });

    if (this.$refs.iframeContainer) {
      this.resizeObserver.observe(this.$refs.iframeContainer);
    }

    this.$refs.iframe.addEventListener('load', () => {
      this.$refs.iframe.contentWindow.addEventListener('message', (event) => {
        const origin = event.origin;
        const data = event.data;

        if(this.isHubspot(origin)){
            if(data.meetingBookSucceeded){
              setTimeout(() => {
                this.$emit('onSuccess', data);
              }, 2000);
            }
        }
        if(this.isCalendly(origin)){
            console.log('Calendly');
        }
        if(this.isGoogleMeet(origin)){
            console.log('Google Meet');
        }
        if(this.isZoom(origin)){
            console.log('Zoom');
        }
      });
    });
  },
  methods: {
    adjustSize() {
      const iframe = this.$refs.iframe;
      const iframeContainer = this.$refs.iframeContainer;

      if (!iframe || !iframeContainer) {
        return;
      }

      const width = this.deviceWidth;
      const scaleFactor = (iframeContainer.clientWidth || 500) / this.deviceWidth;

      this.iframeStyle = {
        width: `${width}px`,
        height: `${iframeContainer.clientHeight / scaleFactor}px`,
        transform: `scale(${scaleFactor})`,
        transformOrigin: "top left",
      };
    },
    isHubspot(origin){
        return /hubspot\.com/.test(origin);
    },
    isCalendly(origin){
        return /calendly\.com/.test(origin);
    },
    isGoogleMeet(origin){
        return /google\.com/.test(origin);
    },
    isZoom(origin){
        return /zoom\.us/.test(origin);
    }
  },
}
</script>

<style>
.sp_meeting_widget_container{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
}
.sp_meeting_widget {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
}
</style>


